import { createContext } from "react";
import { CheckoutScreenContextType } from "../types/checkoutScreenContextTypes";

const CheckoutScreenContext = createContext<undefined | CheckoutScreenContextType>(
  undefined
);

export { CheckoutScreenContext };
